import React, { Component, Fragment } from 'react';
import { loadModules } from 'esri-loader';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import { connect } from 'react-redux';
import { history } from '../../index';
import { reportOperations } from '../../redux/report';
import originFields from '../../defaults/PointOfOriginFields.json'
import { setOriginLayerVisible, getScreenshot } from '../esri/mapHub';
import { refreshOriginLayer } from '../esri/mapHub';
import InvalidateIncidentDialog from './InvalidateIncidentDialog';
import MergeDialog from './MergeDialog';
import Tooltip from '@material-ui/core/Tooltip';
import CircularProgress from 'material-ui/CircularProgress';
import Alert from '@material-ui/lab/Alert';
import theme from '../../muiTheme';
import Button from '@material-ui/core/Button';
import RequiredFieldStatus from './RequiredFieldStatus';

import ButtonGroup from '@material-ui/core/ButtonGroup';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import IncidentResourcesPanel from './IncidentResourcesPanel';
import UniquenessPopover from '../UniquenessPopover';
import RelatedRecordsDialog from './relatedRecords/RelatedRecordsDialog';
import DespliceDialog from './DespliceDialog';
import PrescibedEscapeDialog from './PrescibedEscapeDialog';
import ResourcesDialog from './ResourcesDialog';
import EditLogDialog from '../admin/EditLogDialog';
import { clearOriginSelectionGraphics, setMapViewTarget } from '../esri/mapHub';
import { getIncidentStatus } from '../../utils/incidentHelper';
import Stack from '@mui/material/Stack';
import Chip from '@mui/material/Chip';
import './IncidentDetailsHeader.css';

const buttonStyle =
{
  margin: '10px'
}


class IncidentDetailsHeader extends Component {

  constructor(props) {
    super(props);
    this.state = {
      reportLoading: false,
      showingInvalidateDialog: false,
      showingMergeDialog: false,
      showingPrescribedEscapeDialog: false,
      actionButtonOpen: false,
      generatingUniquenessScore: false,
      resourceReporting: false,
      intersectingIncidents: [],
      uniquenessResults: [],
      uniquenessComplete: false,
      incidentResources: [],
      anchorEl: null,
      uniquenessAnchorEl:null,
      uniquenessMilesBuffer: 15,
      uniquenessDayRange: 14,
      queryIntersectingIncidents: false,
      showingRelatedRecordsDialog: false,
      showingDespliceDialog: false,
      showingResourcesDialog: false,
      resourcesQuerying: false,
      resourcesData: [],
      relatedRecords: null,
      showEditInfo: false,
      editInfoPackage: null
    };

    this.dropdownElement = null;

    this.setDropdownInputRef = element =>
    {
        this.dropdownElement = element;
    };
  }


handleUniquenessClose = () => {
  this.setAnchorEl(null);
  this.setState({
      generatingUniquenessScore: false,
      uniquenessResults: [],
      uniquenessComplete: false
    });
}

handleSpliceComplete = (spliceIncident) =>
{
  this.handleUniquenessClose();

  this.props.onSpliceComplete(spliceIncident.FORID);
}

setAnchorEl = (anchor) => {
  this.setState({
    uniquenessAnchorEl: anchor
  });
}


closeResourcesPanel = () => {
  this.setState({
      resourceReporting: false,
      incidentResources: []
  });
  }

  recenterOnIncident = () => {
    loadModules(['esri/geometry/Point', 'esri/geometry/SpatialReference', 'esri/geometry/projection'])
      .then(([Point, SpatialReference, projection]) => {

        if (this.props.incident.perimeter && this.props.incident.perimeter.Feature) {
          setMapViewTarget({
            target: this.props.incident.perimeter.Feature.geometry
          });
          refreshOriginLayer();
        }
        else {

          const nad83Geometry = new Point({
            x: this.props.incident.attributes.x,
            y: this.props.incident.attributes.y,
            spatialReference: new SpatialReference(4269)
          });

          projection.load().then(function() 
          {
            const originGeometry = projection.project(nad83Geometry, new SpatialReference({wkid: 102100 }));

            setMapViewTarget({
              target: originGeometry.toJSON(),
              zoom: 14
            });
          });

          //const originGeometry = webMercatorUtils.geographicToWebMercator(nad83Geometry);
          //setMapViewTarget({
          //  target: originGeometry.toJSON(),
          //  zoom: 14
          //});
        }
        
        this.setActionsDropdownOpen(false);
      });
  }

  //showEditLog
  showEditLog = (event) =>
    {
      this.setAnchorEl(event.currentTarget);
  
      window.api.searchAdminIncident(this.props.incident.attributes[originFields.uniqueFireId], 'UniqueFireIdentifier').then((response) => 
        {
          this.setState({
            showEditInfo: true,
            editInfoPackage: response
          });
        });
  
      this.setActionsDropdownOpen(false);
    }

    hideEditLogDialog = () =>
      {
        this.setState({
          showEditInfo: false,
          editInfoPackage: null
        });
      }
  
  showUniquenessScorePanel = (event) =>
  {
    this.setAnchorEl(event.currentTarget);

      this.setState({
          generatingUniquenessScore: true,
          uniquenessComplete: true
        });

    this.setActionsDropdownOpen(false);
  }

  closeUniquenessScorePanel = () => {
    this.setState({
        generatingUniquenessScore: false,
        intersectingIncidents: []
    });

    refreshOriginLayer();
  }

    setActionsDropdownOpen = (val) =>
    {
        this.setState({actionButtonOpen: val});
    }

    handleToggle = () =>
    {
      this.setActionsDropdownOpen(!this.state.actionButtonOpen);
    }

    handleClose = (event)  =>
    {
      this.setActionsDropdownOpen(false);
    }

   shareIncident = () =>
    {
      this.setActionsDropdownOpen(false);

      const modDate = moment(this.props.incident.attributes[originFields.informLastModifiedDate]).format('MM/DD/YYYY h:mm A')
      const name = this.props.incident.attributes[originFields.name];
      const ufi = this.props.incident.attributes[originFields.uniqueFireId];
      const lastUser = this.props.incident.attributes[originFields.informUserName];
      const createdBySystem = this.props.incident.attributes[originFields.createdBySystem];
      const status = getIncidentStatus(this.props.incident);

      const baseURL = window.location.origin + window.location.pathname;

      const subject = this.props.incident.attributes[originFields.uniqueFireId];
      const body = `Incident Name: ${name}%0D%0AUnique Fire Identifier: ${ufi}%0D%0ACreated By System: ${createdBySystem}%0D%0ACurrent Status: ${status}%0D%0ALast Modified By Username: ${lastUser}%0D%0ALast Modified On: ${modDate}%0D%0A%0D%0AIncident Link: ${baseURL}`;
      const mailto = `mailto:?subject=InFORM Incident: ${subject}&body=${body}`;

      window.location.href = mailto;
    }

  showRelatedRecords = () =>
   {
     this.setState({showingRelatedRecordsDialog: true});
     this.setActionsDropdownOpen(false);

     window.api.getRelatedRecords(this.props.incident.attributes.FORID).then(resp =>
       {
       this.setState({
         relatedRecords: resp
       });
     });

   }

   hideRelatedRecords = () => {
     this.setState({showingRelatedRecordsDialog: false});
     this.setActionsDropdownOpen(false);

     this.setState({
       relatedRecords: null
     });
   }

   showMergeDialog = () =>
    {
      this.setState({showingMergeDialog: true});
      this.setActionsDropdownOpen(false);
    }

  showInvalidateDialog = () =>
  {
    this.setState({showingInvalidateDialog: true});
    this.setActionsDropdownOpen(false);
  }
 
  //showDespliceDialog
  showDespliceDialog = () =>
  {
    this.setState({showingDespliceDialog: true});
    this.setActionsDropdownOpen(false);
  }

  showResourcesDialog = () =>
    {
      this.setActionsDropdownOpen(false);
      this.setState({
        showingResourcesDialog: true,
        resourcesQuerying: true
      });

      this.setState({resourcesQuerying: true});
      window.api.getResourceData(this.props.incident.attributes[originFields.fireOccurenceRecordID]).then( results =>
      {
        this.setState(
        {
          resourcesQuerying: false,
          resourcesData: results
        });
        });
    }
  
  //showPrescribedEscapeDialog
  showPrescribedEscapeDialog = () =>
  {
    this.setState({showingPrescribedEscapeDialog: true});
    this.setActionsDropdownOpen(false);
  }

  despliceRecord = () =>
  {
    window.api.despliceRecord(this.props.incident.attributes[originFields.fireOccurenceRecordID]).then(result =>
    {
      refreshOriginLayer();
      this.props.onClose();
    });

    this.setState({showingDespliceDialog: false});
  }

  hideDespliceDialog = () =>
  {
    this.setState({showingDespliceDialog: false});
  }
  
  hideResourcesDialog = () =>
    {
      this.setState(
        {
          showingResourcesDialog: false,
          resourcesQuerying: false,
          resourcesData: []
        });
    }

  hidePrescribedEscapeDialog = () =>
  {
    this.setState({showingPrescribedEscapeDialog: false});
  }

  hideInvalidateDialog = () =>
  {
    this.setState({showingInvalidateDialog: false});
  }

  onWasMerged = () => {
    this.setState({showingMergeDialog: false});
    this.props.onClose();
  }
  hideMergeDialog = () =>
  {
    this.setState({showingMergeDialog: false});
  }

  handleInvalidateIncident  = () =>
  {
    this.hideInvalidateDialog();

    clearOriginSelectionGraphics({
       clearExisting: true
     })

    window.api.invalidateIncident(this.props.incident.attributes[originFields.forId]).then(result =>
    {
      refreshOriginLayer();
      this.props.onClose();
    });
  }


  generateReport = () => {
    this.setState({reportLoading: true});
    //Hide the origin feature layer before printing, the custom renderer does not work with the print service.
    //The origin is shown via a graphic layer.
    setOriginLayerVisible(false).then(
      success => {
        getScreenshot(this.props.incident.attributes[originFields.name]).then(
          screenshot => {
            this.props.setScreenshot(screenshot);
            this.setState({reportLoading: false});
            setOriginLayerVisible(true);
            history.push(`/incidents/${this.props.incident.attributes[originFields.forId]}/report`);

          },
          error => {
            this.props.setScreenshot(null);
            this.setState({reportLoading: false});
            setOriginLayerVisible(true);
            history.push(`/incidents/${this.props.incident.attributes[originFields.forId]}/report`);

          }
        );
      }
    );
  }

  render() {
    const missingFieldsButton = (this.props.missingFieldsCount !== 0) ? (
      <RequiredFieldStatus
        chipClicked={this.props.setPanelCollapseFlag}
        missingFields={this.props.missingFieldsCount} />)
      : "";

    const report = this.state.reportLoading ? (
        <CircularProgress size={24} thickness={2} style={{marginRight: "15px", marginTop: "-6px"}} color={theme.palette.primary1Color} />
    ) : (
      <Button
        size="small"
        variant="outlined"
        style={buttonStyle}
        onClick={this.generateReport}>Report</Button>
    );

  const splitButton = (
    <Fragment>
        <ButtonGroup variant="outlined" aria-label="Split button" ref={this.setDropdownInputRef}>
          <Button>Actions</Button>
          <Button
            variant="outlined"
            size="small"
            aria-owns='menu-list-grow'
            aria-haspopup="true"
            onClick={this.handleToggle}>
            <ArrowDropDownIcon />
          </Button>
        </ButtonGroup>
        <Popper open={this.state.actionButtonOpen} anchorEl={this.dropdownElement} transition disablePortal>
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{
                transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom',
              }}
            >
              <Paper id="menu-list-grow">
                <ClickAwayListener onClickAway={this.handleClose}>
                  <MenuList>
                      <MenuItem
                        onClick={this.showInvalidateDialog}
                        disabled={!this.props.canInvalidate || !this.props.auth.isCertifier}>
                        Invalidate
                      </MenuItem>
                      <MenuItem
                        onClick={this.showMergeDialog}
                        disabled={!this.props.canMerge || !this.props.auth.isCertifier}>
                        Merge Into
                      </MenuItem>
                      {(this.props.incident.attributes[originFields.isMultiRoot] === 1) &&
                       <MenuItem
                       onClick={this.showDespliceDialog}
                       disabled={ (!this.props.auth.isCertifier) || (this.props.incident.attributes[originFields.statusId] === 3)}>
                       De-splice
                     </MenuItem>
                      }
                      {(this.props.incident.attributes[originFields.incidentTypeCategory] === 'RX') &&
                       <MenuItem
                       onClick={this.showPrescribedEscapeDialog}
                       disabled={ (!this.props.auth.isCertifier) || (this.props.incident.attributes[originFields.statusId] === 3)}>
                       Associate a Prescribed Escape
                     </MenuItem>
                      }
                      <MenuItem
                        onClick={this.showUniquenessScorePanel}
                        disabled={ (!this.props.incident.attributes.UniquenessRecords) || (!this.props.incident.attributes.UniquenessRecords.length > 0)}>
                        View Uniqueness Scores
                      </MenuItem>
                      <MenuItem
                        onClick={this.showEditLog}>
                        Show Edit Log
                      </MenuItem>
                      <MenuItem
                        onClick={this.showRelatedRecords}>
                        Show related records
                      </MenuItem>
                      <MenuItem
                        onClick={this.shareIncident}>
                        Share via email
                      </MenuItem>
                      <MenuItem
                        onClick={this.recenterOnIncident}>
                        Re-center map
                      </MenuItem>
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </Fragment>
  );

  const relatedRecordCountChip = (this.props.incident && this.props.incident.relatedRecordCount > 1) ?
  ( <Chip style={{marginTop: "16px"}} color="primary" variant="outlined" size="small" label={this.props.incident.relatedRecordCount + " related records"} />)
  : "";

    let actions;
    let editWarning = (this.props.mode !== "read" && this.props.isSaveActive) ?
    (
      (this.props.originValidation.isValid) ?
      (<Alert severity="warning">Note: Changes may take up to 60 seconds to appear</Alert> ) :
      (<Alert severity="warning">Please address data errors below</Alert>)
    )
    : "";

    if (this.props.mode === "read")
    {
        let disabledReason = "";
        //  if (this.props.isCertified || this.props.isReadOnlyUser || this.props.editIsDisabled || !this.props.isDispatchComplete)
        if (this.props.isCertified || this.props.isReadOnlyUser || this.props.editIsDisabled)
        {
          if (this.props.isCertified)
          {
            disabledReason  = "This incident must be decertified before editing.";
          }
            if (this.props.isReadOnlyUser)
            {
              disabledReason  = "You currently have read-only permissions and cannot edit incidents.";
            }

        }
      actions = (
        <div className="incident-details-header-actions">
          {report}
          <Tooltip title={disabledReason} placement="top-start">
          <span><Button
            onClick={this.props.onEdit}
            color="primary"
            variant="outlined"
            size="small"
            style={ (!this.props.isReadOnlyUser ) ? {buttonStyle} : {display: "none"}}
            disabled={(this.props.isCertified || this.props.isReadOnlyUser || this.props.editIsDisabled)}>Edit</Button>
            </span>
          </Tooltip>
          <Button
            onClick={this.props.onClose}
            variant="outlined"
            style={buttonStyle}
            size="small">Close</Button>
          {splitButton}
        </div>
      )
    } else {
      actions = (
        <div className="incident-details-header-actions">
          <Button
            onClick={this.props.onSaveChanges}
            color="primary"
            variant="outlined"
            style={buttonStyle}
            size="small"
            disabled={!this.props.isValid || !this.props.isSaveActive}>
            Save Changes</Button>
          <Button
            onClick={this.props.onCancelEdit}
            variant="outlined"
            style={buttonStyle}
            size="small">
            Cancel</Button>
        </div>
      )
    }

    const uniquenessPopover = this.state.generatingUniquenessScore ? (
      <UniquenessPopover
        open={this.state.generatingUniquenessScore}
        anchorEl={this.dropdownElement}
        milesBuffer={this.state.uniquenessMilesBuffer}
        uniquenessResults={this.props.incident.UniquenessRecords}
        uniquenessComplete={this.state.uniquenessComplete}
        dayRange={this.state.uniquenessDayRange}
        incident={this.props.incident}
        isQuerying={this.state.queryIntersectingIncidents}
        handleClose={this.handleUniquenessClose}
        spliceComplete={this.handleSpliceComplete}
        userIsReadOnly={this.props.isReadOnlyUser} />
    ) : "";

    const resourcesPanel = this.state.resourceReporting ? (
      <IncidentResourcesPanel
        open={this.state.resourceReporting}
        incidentResources={this.state.incidentResources}
        onRequestClose={this.closeResourcesPanel} />
    ) : "";

    return (
      <div className="incident-details-header">
        <div>
        <Stack spacing={2} direction="row"><h3>{this.props.label}</h3>{relatedRecordCountChip}</Stack>
        {actions}
        </div>
        {missingFieldsButton}
        {editWarning}
        <InvalidateIncidentDialog
          open={this.state.showingInvalidateDialog}
          onRequestClose={this.hideInvalidateDialog}
          onRequestInvalidate={this.handleInvalidateIncident}
          />
          <RelatedRecordsDialog
            open={this.state.showingRelatedRecordsDialog}
            relatedRecords={this.state.relatedRecords}
            onRequestClose={this.hideRelatedRecords} />
            <MergeDialog
            open={this.state.showingMergeDialog}
            incident={this.props.incident}
            onWasMerged={this.onWasMerged}
            onMergeClose={this.hideMergeDialog} />
          <DespliceDialog
            open={this.state.showingDespliceDialog}
            incident={this.props.incident}
            onWasDespliced={this.onWasDespliced}
            onRequestClose={this.hideDespliceDialog}
            despliceRecordConfirmed={this.despliceRecord} />
          <ResourcesDialog
            open={this.state.showingResourcesDialog}
            isQuerying={this.state.resourcesQuerying}
            resourcesData={this.state.resourcesData} 
            onClose={this.hideResourcesDialog} />
          <EditLogDialog 
            open={this.state.showEditInfo} 
            editInfoPackage={this.state.editInfoPackage}
            onClose={this.hideEditLogDialog} />
           <PrescibedEscapeDialog
            open={this.state.showingPrescribedEscapeDialog}
            incident={this.props.incident}
            onCloseEscapeDialog={this.hidePrescribedEscapeDialog} />
        {uniquenessPopover}
        {resourcesPanel}
      </div>
    );
  }
}

const mapStateToProps = state => ({
    auth: state.auth
})

const mapDispatchToProps = function (dispatch) {
  return bindActionCreators({
    ...reportOperations
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(IncidentDetailsHeader)
